export function pascalToCamelCase(input: string): string {
    if (typeof input !== 'string' || input.length === 0) {
        return '';
    }
    return input[0].toLowerCase() + input.slice(1);
}
